// extracted by mini-css-extract-plugin
module.exports = {"heading":"PlayfulMinimalHeader_heading__8sEcI","logo":"PlayfulMinimalHeader_logo__Muu69"};